import { FC, useEffect, useState } from 'react';

interface Props {
  activeClassName: string;
  value: number;
  max: number;
  isActive: boolean;
  stagger: number;
  visibleIndex: number;
}

export const BarChartEntryBar: FC<Props> = ({
  stagger,
  activeClassName,
  value,
  max,
  isActive,
  visibleIndex,
}) => {
  const [maskRef, setMaskRef] = useState<HTMLDivElement | null>(null);
  const resetBar = () => {
    return new Promise<void>((res, rej) => {
      if (!maskRef) {
        rej();
        return;
      }
      maskRef.style.transitionDuration = '0s';
      maskRef.style.transitionDelay = '0s';
      maskRef.style.height = '0';
      setTimeout(() => {
        maskRef.style.removeProperty('transition-duration');
        maskRef.style.transitionDelay = `${visibleIndex * stagger}s`;
        res();
      }, 100);
    });
  };
  const animateBar = () => {
    if (!maskRef) return;
    if (maskRef.clientHeight === 0) {
      maskRef.style.height = `${(value / max) * 100}%`;
    }
  };
  useEffect(() => {
    if (!maskRef || visibleIndex === -1) return;
    animateBar();
  }, [maskRef, visibleIndex]);
  useEffect(() => {
    if (!maskRef) return;
    resetBar().then(() => {
      if (visibleIndex === -1) return;
      animateBar();
    });
  }, [isActive]);
  return (
    <div className="bar-chart-entry__bar-wrapper">
      <div
        ref={setMaskRef}
        className="bar-chart-entry__mask"
        style={{
          transitionDelay: `${visibleIndex * stagger}s`,
        }}
      >
        <div
          className={`bar-chart-entry__bar ${isActive ? activeClassName : ''}`}
        />
      </div>
    </div>
  );
};
